// ALPHAKART LANDING PAGE INTERACTION ENGINE

document.addEventListener("DOMContentLoaded", () => {
    const $ = (selector, scope = document) => scope.querySelector(selector);
    const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
    const setText = (element, value) => {
        if (element) {
            element.textContent = value;
        }
    };

    const formatPrice = (amount) => `₹${amount}.00`;
    const digitsOnly = (value) => value.replace(/\D/g, "");
    const cleanText = (value, maxLength) => (
        value
            .replace(/<[^>]*>/g, " ")
            .replace(/[<>]/g, "")
            .replace(/[\u0000-\u001F\u007F]/g, " ")
            .replace(/\s+/g, " ")
            .trim()
            .slice(0, maxLength)
    );

    let currentBundle = {
        id: 1,
        qty: "Pack of 1",
        price: 279,
        compare: 349,
        discount: 20
    };

    let cartCount = 0;
    let modalReturnFocus = null;

    const mainHeader = $(".main-header");
    const menuToggle = $("#menuToggle");
    const primaryNav = $("#primaryNav");
    const bundleCards = $$(".bundle-card");
    const mainPrice = $("#mainPriceDisplay");
    const mainComparePrice = $("#mainComparePriceDisplay");
    const mainDiscount = $("#mainDiscountDisplay");
    const stickyPrice = $("#stickyPriceDisplay");
    const stickyCompare = $("#stickyCompareDisplay");
    const stickyBar = $("#stickyMobileBar");
    const buyNowBtn = $("#buyNowBtn");
    const stickyBuyNowBtn = $("#stickyBuyNowBtn");
    const addToCartBtn = $("#addToCartBtn");
    const cartToggle = $("#cartToggle");
    const cartBadgeCount = $("#cartBadgeCount");
    const codModal = $("#codModal");
    const modalCloseBtn = $("#modalCloseBtn");
    const modalOverlay = $("#modalOverlay");
    const codForm = $("#codCheckoutForm");
    const formError = $("#formError");
    const successScreen = $("#successScreen");
    const closeSuccessBtn = $("#closeSuccessBtn");
    const summaryBundleQty = $("#summaryBundleQty");
    const summaryTotalAmount = $("#summaryTotalAmount");
    const successCustomerName = $("#successCustomerName");
    const successBundleName = $("#successBundleName");
    const successTotal = $("#successTotal");
    const liveStockCount = $("#liveStockCount");
    const geoCityName = $("#geoCityName");
    const buyBoxSection = $("#buyBoxSection");
    const productsSection = $("#products");
    const mainProductImage = $("#mainProductImage");
    const galleryThumbs = $$(".product-gallery-thumb");
    const galleryPrev = $(".product-gallery-prev");
    const galleryNext = $(".product-gallery-next");
    const homeProductsTrack = $("#homeProductsTrack");
    const homeProductPrev = $(".home-product-slider-prev");
    const homeProductNext = $(".home-product-slider-next");
    const shopifyProductForm = $("#AlphaShopifyProductForm");
    const shopifyQuantity = $("#AlphaShopifyQuantity");
    const shopifyReturnTo = $("#AlphaShopifyReturnTo");

    const formFields = {
        fullName: $("#fullName"),
        mobileNumber: $("#mobileNumber"),
        pinCode: $("#pinCode"),
        city: $("#city"),
        state: $("#state"),
        addressLine1: $("#addressLine1"),
        addressLine2: $("#addressLine2"),
        country: $("#country")
    };

    const showFormError = (message) => {
        if (!formError) {
            return;
        }

        formError.textContent = message;
        formError.classList.remove("hidden");
    };

    const clearFormError = () => {
        if (!formError) {
            return;
        }

        formError.textContent = "";
        formError.classList.add("hidden");
    };

    const setCartCount = (count) => {
        const parsedCount = Number.parseInt(count, 10);
        cartCount = Number.isFinite(parsedCount) ? Math.max(0, parsedCount) : 0;
        setText(cartBadgeCount, String(cartCount));
    };

    const syncCartCount = async () => {
        if (!cartBadgeCount) {
            return null;
        }

        const response = await fetch("/cart.js", {
            headers: { "Accept": "application/json" },
            cache: "no-store"
        });

        if (!response.ok) {
            throw new Error("Unable to load cart");
        }

        const cart = await response.json();
        setCartCount(cart.item_count);
        return cart;
    };

    const renderedCartCount = Number.parseInt(cartBadgeCount?.textContent || "0", 10);
    setCartCount(renderedCartCount);
    syncCartCount().catch(() => {});
    window.addEventListener("pageshow", () => syncCartCount().catch(() => {}));

    const setGalleryImage = (thumb) => {
        if (!thumb) {
            return;
        }

            const nextImage = thumb.dataset.galleryImage;
            if (!mainProductImage || !nextImage) {
                return;
            }

            mainProductImage.src = nextImage;
            galleryThumbs.forEach((item) => {
                const isActive = item === thumb;
                item.classList.toggle("active", isActive);
                item.setAttribute("aria-pressed", String(isActive));
            });
            thumb.scrollIntoView({ block: "nearest", inline: "nearest" });
    };

    const moveGallery = (direction) => {
        if (!galleryThumbs.length) {
            return;
        }

        const currentIndex = Math.max(0, galleryThumbs.findIndex((thumb) => thumb.classList.contains("active")));
        const nextIndex = (currentIndex + direction + galleryThumbs.length) % galleryThumbs.length;
        setGalleryImage(galleryThumbs[nextIndex]);
    };

    galleryThumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => setGalleryImage(thumb));
    });

    galleryPrev?.addEventListener("click", () => moveGallery(-1));
    galleryNext?.addEventListener("click", () => moveGallery(1));

    let isHomeSliderAnimating = false;

    const setHomeSliderActiveCard = () => {
        if (!homeProductsTrack) {
            return;
        }

        const cards = $$(".home-product-card", homeProductsTrack);
        const activeIndex = window.matchMedia("(max-width: 767px)").matches ? 0 : 1;
        cards.forEach((card, index) => {
            const isActive = index === Math.min(activeIndex, cards.length - 1);
            card.classList.toggle("is-active", isActive);
            card.setAttribute("aria-current", isActive ? "true" : "false");
        });
    };

    const updateHomeProductButtons = () => {
        if (!homeProductsTrack || !homeProductPrev || !homeProductNext) {
            return;
        }

        homeProductPrev.disabled = false;
        homeProductNext.disabled = false;
        setHomeSliderActiveCard();
    };

    const slideHomeProducts = (direction) => {
        if (!homeProductsTrack || isHomeSliderAnimating) {
            return;
        }

        const cards = $$(".home-product-card", homeProductsTrack);
        if (cards.length < 2) {
            return;
        }

        const gap = Number.parseFloat(getComputedStyle(homeProductsTrack).columnGap) || 0;
        const cardWidth = cards[0].getBoundingClientRect().width;
        const offset = cardWidth + gap;

        isHomeSliderAnimating = true;

        if (direction < 0) {
            homeProductsTrack.prepend(cards[cards.length - 1]);
            homeProductsTrack.style.transform = `translate3d(-${offset}px, 0, 0)`;
            homeProductsTrack.getBoundingClientRect();
            requestAnimationFrame(() => {
                homeProductsTrack.classList.add("is-animating");
                homeProductsTrack.style.transform = "translate3d(0, 0, 0)";
            });
        } else {
            homeProductsTrack.classList.add("is-animating");
            homeProductsTrack.style.transform = `translate3d(-${offset}px, 0, 0)`;
        }

        window.setTimeout(() => {
            if (direction > 0) {
                homeProductsTrack.append(cards[0]);
            }

            homeProductsTrack.classList.remove("is-animating");
            homeProductsTrack.style.transform = "translate3d(0, 0, 0)";
            isHomeSliderAnimating = false;
            setHomeSliderActiveCard();
        }, 175);
    };

    homeProductPrev?.addEventListener("click", () => slideHomeProducts(-1));
    homeProductNext?.addEventListener("click", () => slideHomeProducts(1));
    homeProductsTrack?.addEventListener("scroll", updateHomeProductButtons, { passive: true });
    window.addEventListener("resize", updateHomeProductButtons);
    updateHomeProductButtons();

    const updateBundleFromCard = (card) => {
        const bundleId = Number(card.dataset.bundle);
        const price = Number(card.dataset.price);
        const compare = Number(card.dataset.compare);
        const discount = Number(card.dataset.discount);
        const qtyText = $(".bundle-qty", card)?.textContent.trim() || "Pack of 1";

        if (![bundleId, price, compare, discount].every(Number.isFinite)) {
            return;
        }

        currentBundle = {
            id: bundleId,
            qty: qtyText,
            price,
            compare,
            discount
        };

        bundleCards.forEach((bundleCard) => {
            const isSelected = bundleCard === card;
            bundleCard.classList.toggle("selected", isSelected);
            bundleCard.setAttribute("aria-pressed", String(isSelected));
        });

        setText(mainPrice, formatPrice(price));
        setText(mainComparePrice, formatPrice(compare));
        setText(mainDiscount, `SAVE ₹${Math.max(0, compare - price)}`);
        setText(stickyPrice, `₹${price}`);
        setText(stickyCompare, `₹${compare}`);
        setText(summaryBundleQty, qtyText);
        setText(summaryTotalAmount, formatPrice(price));
    };

    bundleCards.forEach((card) => {
        card.addEventListener("click", () => updateBundleFromCard(card));
        card.addEventListener("keydown", (event) => {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                updateBundleFromCard(card);
            }
        });
    });

    const selectedBundleCard = bundleCards.find((card) => card.classList.contains("selected"));
    if (selectedBundleCard) {
        updateBundleFromCard(selectedBundleCard);
    }

    const closeMobileNav = () => {
        mainHeader?.classList.remove("nav-open");
        menuToggle?.setAttribute("aria-expanded", "false");
    };

    menuToggle?.addEventListener("click", () => {
        const willOpen = !mainHeader?.classList.contains("nav-open");
        mainHeader?.classList.toggle("nav-open", willOpen);
        menuToggle.setAttribute("aria-expanded", String(willOpen));
    });

    primaryNav?.addEventListener("click", (event) => {
        if (event.target instanceof HTMLAnchorElement) {
            closeMobileNav();
        }
    });

    const checkScrollPosition = () => {
        if (!buyNowBtn || !stickyBar) {
            return;
        }

        const buyBoxTrigger = buyNowBtn.getBoundingClientRect().bottom;
        stickyBar.classList.toggle("visible", buyBoxTrigger < 0);
    };

    window.addEventListener("scroll", checkScrollPosition, { passive: true });
    checkScrollPosition();

    const openCheckoutModal = () => {
        if (!codModal || !codForm || !successScreen) {
            return;
        }

        modalReturnFocus = document.activeElement;
        codModal.classList.add("open");
        codModal.setAttribute("aria-hidden", "false");
        document.body.classList.add("modal-open");
        clearFormError();
        codForm.classList.remove("hidden");
        successScreen.classList.add("hidden");
        window.setTimeout(() => formFields.fullName?.focus(), 0);
    };

    const closeCheckoutModal = () => {
        if (!codModal || !codForm || !successScreen) {
            return;
        }

        codModal.classList.remove("open");
        codModal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("modal-open");
        clearFormError();
        codForm.classList.remove("hidden");
        successScreen.classList.add("hidden");
        codForm.reset();

        if (modalReturnFocus instanceof HTMLElement) {
            modalReturnFocus.focus();
        }
    };

    const shopifyVariantInput = shopifyProductForm?.querySelector('input[name="id"]');

    const getSelectedShopifyItem = () => {
        const id = shopifyVariantInput?.value;
        if (!id) {
            return null;
        }

        return {
            id,
            quantity: currentBundle.id || 1
        };
    };

    const addShopifyProduct = async () => {
        const item = getSelectedShopifyItem();
        if (!item) {
            return false;
        }

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({ items: [item] })
        });

        if (!response.ok) {
            throw new Error("Unable to add product to cart");
        }

        return true;
    };

    const submitShopifyProduct = async (returnTo) => {
        if (!shopifyProductForm) {
            openCheckoutModal();
            return;
        }

        try {
            await addShopifyProduct();
            window.location.href = returnTo;
        } catch (error) {
            if (shopifyQuantity) {
                shopifyQuantity.value = String(currentBundle.id || 1);
            }

            if (shopifyReturnTo) {
                shopifyReturnTo.value = returnTo;
            }

            shopifyProductForm.requestSubmit();
        }
    };

    buyNowBtn?.addEventListener("click", () => submitShopifyProduct("/checkout"));
    stickyBuyNowBtn?.addEventListener("click", () => submitShopifyProduct("/checkout"));
    modalCloseBtn?.addEventListener("click", closeCheckoutModal);
    modalOverlay?.addEventListener("click", closeCheckoutModal);
    closeSuccessBtn?.addEventListener("click", closeCheckoutModal);

    document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") {
            return;
        }

        closeMobileNav();
        if (codModal?.classList.contains("open")) {
            closeCheckoutModal();
        }
    });

    addToCartBtn?.addEventListener("click", () => {
        if (shopifyProductForm) {
            addShopifyProduct()
                .then(() => syncCartCount())
                .then(() => {
                    setText(addToCartBtn, "ADDED TO CART! ✓");
                    addToCartBtn.classList.add("is-added");

                    window.setTimeout(() => {
                        setText(addToCartBtn, "ADD TO CART");
                        addToCartBtn.classList.remove("is-added");
                    }, 1500);
                })
                .catch(() => {
                    setText(addToCartBtn, "TRY AGAIN");
                    window.setTimeout(() => setText(addToCartBtn, "ADD TO CART"), 1500);
                });
            return;
        }

        setCartCount(cartCount + currentBundle.id);

        setText(addToCartBtn, "ADDED TO CART! ✔");
        addToCartBtn.classList.add("is-added");

        window.setTimeout(() => {
            setText(addToCartBtn, "ADD TO CART");
            addToCartBtn.classList.remove("is-added");
        }, 1500);
    });

    cartToggle?.addEventListener("click", () => {
        window.location.href = "/cart";
    });

    formFields.mobileNumber?.addEventListener("input", () => {
        formFields.mobileNumber.value = digitsOnly(formFields.mobileNumber.value).slice(0, 10);
    });

    formFields.pinCode?.addEventListener("input", () => {
        formFields.pinCode.value = digitsOnly(formFields.pinCode.value).slice(0, 6);
    });

    Object.values(formFields).forEach((field) => {
        field?.addEventListener("input", clearFormError);
    });

    codForm?.addEventListener("invalid", () => {
        showFormError("Please complete all shipping fields with valid details.");
    }, true);

    codForm?.addEventListener("submit", (event) => {
        event.preventDefault();
        clearFormError();

        const customerName = cleanText(formFields.fullName?.value || "", 80);
        const mobileNumber = digitsOnly(formFields.mobileNumber?.value || "");
        const pinCode = digitsOnly(formFields.pinCode?.value || "");
        const city = cleanText(formFields.city?.value || "", 60);
        const state = cleanText(formFields.state?.value || "", 60);
        const addressLine1 = cleanText(formFields.addressLine1?.value || "", 120);
        const addressLine2 = cleanText(formFields.addressLine2?.value || "", 120);
        const country = cleanText(formFields.country?.value || "", 60);

        if (formFields.fullName) formFields.fullName.value = customerName;
        if (formFields.mobileNumber) formFields.mobileNumber.value = mobileNumber;
        if (formFields.pinCode) formFields.pinCode.value = pinCode;
        if (formFields.city) formFields.city.value = city;
        if (formFields.state) formFields.state.value = state;
        if (formFields.addressLine1) formFields.addressLine1.value = addressLine1;
        if (formFields.addressLine2) formFields.addressLine2.value = addressLine2;
        if (formFields.country) formFields.country.value = country;

        if (!codForm.checkValidity()) {
            showFormError("Please complete all shipping fields with valid details.");
            codForm.reportValidity();
            return;
        }

        if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
            showFormError("Please enter a valid 10-digit Indian mobile number.");
            formFields.mobileNumber?.focus();
            return;
        }

        if (!/^\d{6}$/.test(pinCode)) {
            showFormError("Please enter a valid 6-digit PIN code.");
            formFields.pinCode?.focus();
            return;
        }

        const firstName = customerName.split(" ")[0] || "Customer";
        setText(successCustomerName, firstName);
        setText(successBundleName, currentBundle.qty);
        setText(successTotal, formatPrice(currentBundle.price));

        codForm.classList.add("hidden");
        successScreen?.classList.remove("hidden");
        setCartCount(0);
    });

    const tier1Cities = [
        "Delhi-NCR", "Mumbai", "Bengaluru", "Kolkata",
        "Chennai", "Hyderabad", "Pune", "Ahmedabad", "Gurgaon"
    ];

    const updateDynamicCityName = () => {
        if (!geoCityName) {
            return;
        }

        const hour = new Date().getHours();
        geoCityName.textContent = tier1Cities[hour % tier1Cities.length];
    };

    updateDynamicCityName();

    let stock = 9;
    const updateStockCountdown = () => {
        if (!liveStockCount || stock <= 2) {
            return;
        }

        if (Math.random() > 0.4) {
            stock -= 1;
            liveStockCount.textContent = String(stock);
            liveStockCount.classList.toggle("is-critical", stock <= 4);
        }
    };

    window.setInterval(updateStockCountdown, 35000);
});
